var _path, _g, _path2, _path3, _path4, _g2, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 63,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 33768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.2475 31.1217C62.2774 13.9954 48.4316 0.0874925 31.3221 0.057614C14.2126 0.0277354 0.318342 13.8872 0.288467 31.0135C0.258593 48.1398 14.1044 62.0477 31.2139 62.0775C48.3234 62.1074 62.2177 48.248 62.2475 31.1217Z",
    fill: "#14B9AA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_49_4954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M62.2475 31.1217C62.2774 13.9954 48.4316 0.0874925 31.3221 0.057614C14.2126 0.0277354 0.318342 13.8872 0.288467 31.0135C0.258593 48.1398 14.1044 62.0477 31.2139 62.0775C48.3234 62.1074 62.2177 48.248 62.2475 31.1217Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_49_4954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.1064 28.4531C16.9366 28.7031 16.3976 50.2731 20.1914 54.6931H41.6165C41.6165 54.6931 47.467 38.1331 43.4835 28.4531H16.9766",
    fill: "#0C0000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M37.5638 40.3047H25.7031V48.3047H37.5638V40.3047Z",
    fill: "#FABB9F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5785 46.0925C30.3655 46.8025 32.3224 47.2325 34.2493 47.2525C35.3575 47.2525 36.4756 47.1225 37.5638 46.9325V40.3125H25.7031V44.4525C26.5318 45.1825 27.6 45.7125 28.5785 46.1025V46.0925Z",
    fill: "#E6E7E8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.4801 25.2564C44.52 24.9664 45.0192 24.4864 45.2389 24.3164C45.7281 23.9564 46.2173 24.3264 46.3571 24.7964C46.4869 25.2164 46.4969 25.6864 46.5268 26.1264C46.6067 27.1864 46.4369 28.2364 45.9577 29.1864C45.6382 29.8264 45.139 30.3564 44.5499 30.7464C44.5499 30.7464 43.911 31.0664 43.7812 30.3364C43.7812 30.3364 44.4701 25.2564 44.4701 25.2464L44.4801 25.2564Z",
    fill: "#FABB9F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M44.3842 25.8851C44.4141 25.6751 44.7736 25.3352 44.9234 25.2152C45.2728 24.9552 45.6222 25.2152 45.722 25.5552C45.8119 25.8552 45.8218 26.1951 45.8418 26.5051C45.8917 27.2651 45.7819 28.0151 45.4324 28.6951C45.2028 29.1551 44.8435 29.5251 44.4242 29.8151C44.4242 29.8151 43.9649 30.0451 43.875 29.5151L44.3742 25.8752L44.3842 25.8851Z",
    fill: "#DCA68E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M18.4842 25.2564C18.4442 24.9664 17.945 24.4864 17.7254 24.3164C17.2362 23.9564 16.747 24.3264 16.6072 24.7964C16.4774 25.2164 16.4675 25.6864 16.4375 26.1264C16.3676 27.1864 16.5273 28.2364 17.0066 29.1864C17.326 29.8264 17.8253 30.3564 18.4143 30.7464C18.4143 30.7464 19.0533 31.0664 19.1831 30.3364C19.1831 30.3364 18.4942 25.2564 18.4942 25.2464L18.4842 25.2564Z",
    fill: "#FABB9F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.5862 25.8851C18.5563 25.6751 18.1969 25.3352 18.0472 25.2152C17.6977 24.9552 17.3482 25.2152 17.2484 25.5552C17.1585 25.8552 17.1486 26.1951 17.1286 26.5051C17.0787 27.2651 17.1885 28.0151 17.538 28.6951C17.7676 29.1551 18.127 29.5251 18.5464 29.8151C18.5464 29.8151 19.0056 30.0451 19.0954 29.5151L18.5962 25.8752L18.5862 25.8851Z",
    fill: "#DCA68E"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M44.8632 26.2047C44.8632 29.5547 44.2841 32.9447 42.7067 35.8547C41.3289 38.3947 39.2523 40.4247 37.026 42.0447C35.2189 43.3647 33.292 44.8947 31.0057 44.7047C28.6296 44.5047 26.7726 42.4747 25.0355 40.8947C22.5895 38.6647 20.6625 35.8947 19.4745 32.6447C18.7456 30.6347 18.4062 28.3747 18.4062 26.2147C18.4062 15.3747 24.3266 8.55469 31.6347 8.55469C38.9428 8.55469 44.8632 15.3747 44.8632 26.2147V26.2047Z",
    fill: "#FABB9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M49.6891 51.9247L36.8101 48.0547H26.4769L13.5979 51.9247C13.5979 51.9247 7.62768 54.4647 6.96875 62.5147H56.3384C55.6794 54.4747 49.7091 51.9247 49.7091 51.9247H49.6891Z",
    fill: "#FABB9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M49.6857 51.9212L42.5573 49.7812L31.6251 60.7113L20.663 49.7912L13.5745 51.9212C13.5745 51.9212 7.60424 54.4612 6.94531 62.5112H56.3149C55.656 54.4712 49.6857 51.9212 49.6857 51.9212Z",
    fill: "#EB524F"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M22.6484 12.8561C22.6484 12.8561 29.018 22.9761 44.8223 24.6961C44.8223 24.6961 47.8074 13.1661 36.7055 7.56614C36.7055 7.56614 28.1994 4.05614 22.6584 12.8561H22.6484Z",
    fill: "#3B2314"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M24.2921 14.9044C24.2921 14.9044 20.1786 17.5644 18.3915 25.0044C18.3915 25.0044 16.4746 10.9844 26.3787 9.23438L24.2921 14.8944V14.9044Z",
    fill: "#3B2314"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M40.4325 23.5284C40.4325 23.5284 44.6757 50.5284 37.9766 58.1684C37.9766 58.1684 46.5426 56.8984 46.9719 45.0884C46.9719 45.0884 48.4994 20.9684 42.6989 12.6484L40.4425 23.5184L40.4325 23.5284Z",
    fill: "#3B2314"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M22.3167 58.1728C22.3167 58.1728 12.4527 57.0028 15.1683 26.6328C15.1683 26.6328 15.8471 9.77281 25.7111 9.38281L25.1421 15.7828C25.1421 15.7828 19.4713 17.4728 20.2001 30.8128C20.2001 30.8128 19.6211 52.3128 22.3167 58.1728Z",
    fill: "#3B2314"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.19bd141e2fa3ec5a20e44aff4f0bdee0.svg";
export { ForwardRef as ReactComponent };